import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { get, pick, merge } from 'lodash';

// import * as companyApi from '../../../../../redux/actionCreators/async/companies';
// import * as companyStore from '../../../../../redux/actionCreators/sync/companies';

import { validate, validateField } from '../../../../../modelValidator';

import MaskedTextField from '../../../../../common/components/c_MaskedTextField';
import TextField from '../../../../../common/components/c_TextField';
import Button from '../../../../../common/components/Button';
import SimpleDropDownMenu from '../../../../../common/components/SimpleDropDownMenu';
import ModalX from '../../../../../common/svgs/ModalX';

import AdditionalContactModel from '../AdditionalContactModel';

const addButtonStyle = {
  width: '165px',
  transition: 'color 450ms cubic-bezier(0.23, 1, 0.32, 1), border-color 450ms cubic-bezier(0.23, 1, 0.32, 1)'
};

@connect((store) => {
	return {
		staticData: store.staticData,
		user: store.user,
		companyContacts: store.companyContacts
	};
})
export default class AddAdditionalContacts extends Component {

	static propTypes = {
		staticData: PropTypes.object.isRequired,
		user: PropTypes.object,
		cancel: PropTypes.func,
		selectContact: PropTypes.func,
		companyContacts: PropTypes.object,
		dispatch: PropTypes.func,
    handleChange: PropTypes.func,
    contact: PropTypes.object,
	}
	constructor(props, context) {
		super(props, context);

		this.state = {
			dirty: false,
			submitted: false,
			errors: [],
			jobRequest: null
		};

		this.AdditionalContactModel = AdditionalContactModel.getModel();
		this.handleDropDownMenuUI = ::this.handleDropDownMenuUI;
		this.handleUI = ::this.handleUI;
		this.handleChange = ::this.handleChange;
		this.validate = ::this.validate;
	}

	handleDropDownMenuUI(prop, menuItems, label) {
		return {
			'data-id': prop,
			value: this.props.contact[prop],
			menuItems,
			floatingLabelText: label,
			errorText: this.validate(prop),
			onChange: this.handleChange(prop),
      isDirty: this.state.dirty,
      validation: this.AdditionalContactModel[prop]
		};
	}

	validate(prop) {

    // if (!this.state.submitted) {
    //   return;
    // }

		const message = this.state.errors[0];
		const validation = validateField(this.props.contact[prop], this.AdditionalContactModel[prop]);

		if (prop === 'email' && message && message.search('email') !== -1) {
			return message;
		} else {
			return validation[0];
		}
	}

	handleUI(prop, label) {

		return {
			'data-id': prop,
      key: `${prop}-${this.props.contact[prop]}`,
			defaultValue: this.props.contact[prop],
			floatingLabelText: label,
			onBlur: this.handleChange(prop),
			isDirty: this.state.dirty,
			errorText: this.validate(prop),
		};
	}

  handleChange(prop) {
    return (event, value) => {
      // update contact in parent state
      this.props.handleChange(prop, value);

      // update dirty in local state
      this.setState({ dirty: true});
    };
  }

  render() {
    return (
      <div className='add-additional-contacts'>
        <div className='add-additional-contacts-header'>
          <h1>Add New Reporting Contact</h1>
          <ModalX
            className='close-add-additional-contacts'
            onClick={this.props.cancel}
            fill={'#000000'}
          />
        </div>
        <div className='box-container-fixed'>
          <div className='box'>
            <TextField
              {...this.handleUI('firstName', 'First Name')} />
          </div>
          <div className='box'>
            <TextField
              {...this.handleUI('lastName', 'Last Name')} />
          </div>
          <div className='box'>
            <TextField
              {...this.handleUI('title', 'Title')} />
          </div>

          <div className='box'>
            <div className='box-c'>
              <div className='box-i'>
                <MaskedTextField
                  hideMaskChar
                  mask='(999) 999-9999'
                  {...this.handleUI('phoneNumber1', 'Phone Number')} />
              </div>
              <div className='box-i'>
                <TextField
                  {...this.handleUI('phoneExtension1', 'Extension')} />
              </div>
            </div>
          </div>
          <div className='box'>
            <TextField
              {...this.handleUI('email', 'Email Address')} />
          </div>
          <div className='box'>
            <TextField
              {...this.handleUI('address', 'Address')} />
          </div>
          <div className='box'>
            <TextField
              {...this.handleUI('city', 'City')} />
          </div>
          <div className='box'>
            <div className='box-c'>
              <div className='box-i'>
                <SimpleDropDownMenu
                  {...this.handleDropDownMenuUI('state', this.props.staticData.stateList, 'State')}
                  underlineStyle={{margin: '-1px 0px'}}
                  iconStyle={{right: '0px', fill: 'rgb(33, 35, 38)'}}
                  labelStyle={{paddingLeft: '0px'}}
                 />
              </div>
              <div className='box-i'>
                <TextField
                  type='number'
                  maxLength='5'
                  {...this.handleUI('zip', 'Zip')} />
              </div>
            </div>
          </div>
        </div>
      </div>
      );
    }
  }



// WEBPACK FOOTER //
// ./shared/react/client/JobRequest/AdditionalContacts/AddAdditionalContacts/index.js